package com.mgacreative.hotel.feature.admin.di

import com.mgacreative.hotel.feature.admin.ui.*
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

fun getAdminFeatureModule() = module {
    viewModel { AdminViewModel(get(), get()) }
    viewModel { AdminMembersViewModel(get(), get()) }
    viewModel { AdminRoomViewModel(get(), get()) }
    viewModel { AdminPricingViewModel(get(), get(), get()) }
    viewModel { AdminSupplierViewModel(get()) }
    viewModel { AdminAgencyViewModel(get()) }
    viewModel { AdminDepartmentViewModel(get()) }
    viewModel { AdminStaffViewModel(get(), get(), get()) }
    viewModel { AdminBlacklistViewModel(get()) }
    viewModel { AdminMenuViewModel(get()) }
    viewModel { FloorPlanViewModel(get(), get()) }
}
